import {conditionCardSchema} from '../../../../../schemas/conditionCardSchema';
import {z} from 'zod';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {DTConditionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {DateTime} from 'luxon';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

export function convertConditionAICardToAPICard(
  conditionCard: z.input<typeof conditionCardSchema>,
  existingCard: DTConditionNode,
) {
  const outputs = conditionCard.outputs.map((output, index) => ({
    nodeId: existingCard?.outputs?.[index]?.nodeId ?? NO_NODE_ID,
    id: index + 1,
    name: output.name ?? `Output ${index + 1}`,
    type: OutputType.Regular,
    ...(output.booleanValue && {booleanValue: output.booleanValue}),
    ...(output.dateValues && {dateValues: output.dateValues.map((date) => DateTime.fromISO(date))}),
    ...(output.datesRange && {
      datesRange: output.datesRange
        ? {
            from: DateTime.fromISO(output.datesRange.from),
            to: DateTime.fromISO(output.datesRange.to),
          }
        : null,
    }),
    ...(output.numericValues && {numericValues: output.numericValues}),
    ...(output.textValues && {textValues: output.textValues}),
  }));

  if (!outputs.some((output) => output.type === OutputType.Fallback)) {
    outputs.push({
      id: outputs.length + 1,
      name: 'Fallback',
      type: OutputType.Fallback,
      nodeId: NO_NODE_ID,
      textValues: [],
      numericValues: [],
      dateValues: [],
      datesRange: null,
      booleanValue: undefined,
    });
  }

  return {
    ...getAICardBaseDetails(conditionCard),
    ...conditionCard,
    type: NodeType.CONDITION,
    outputs,
    inputs: [],
  } as DTConditionNode;
}
